import { List, ListItem, Popover, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import { formatAddress } from "src/services/utils";

export default function PoolListPopover({ poolList, ...props }) {
  const history = useHistory();

  function onRowClick(pool) {
    history.push(`/pool-monitoring/${pool.address}`);
    props?.onClose();
  }

  return (
    <Popover {...props} PaperProps={{ style: { padding: "0rem 0.5rem" } }}>
      <List>
        {poolList.map((pool, index) => {
          return (
            <ListItem button key={index} onClick={() => onRowClick(pool)} style={{ borderRadius: "5px" }}>
              <Typography color="textSecondary">{`${pool.name}(${formatAddress(pool.address, 3)})`}</Typography>
            </ListItem>
          );
        })}
      </List>
    </Popover>
  );
}
